//ModalEditAsset
import React, { useEffect, useState } from "react";
import { Row, Col, Card, Checkbox, Divider, Space, Upload, Button, Form, Input, DatePicker, Radio, message, Modal, Select, Image, Spin, } from "antd";
import Compressor from 'compressorjs';
import { DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import axios from "axios";
import { DELETE_ASSETLANDAREA, DELETE_IMAGE_NOT_ASSET, GET_LOAD_IMAGE, POST_ADD_ASSET, POST_EDIT_ASSET, POST_LOAD_ASSET, POST_UPLOAD_IMAGE } from "../../../API/apiUrls";
import ModalAssetForEdit from "./ModalAssetForEdit";
import ModalEditOwnerBeforeSave from "./ModalEditOwnerBeforeSave";
import ModelViewData from "./ModelViewData";
const { Option } = Select;
const { confirm } = Modal;

function ModalEditAsset({ open, onClose, index, handleLoadEdit, dataForEdit, datas }) {
    const [form] = Form.useForm(); // form หลัก
    const [formaddperson] = Form.useForm(); // เพิ่มเจ้าของทรัพย์
    const [formradio] = Form.useForm(); // radio, checkbox
    const [seizedForm] = Form.useForm(); // ติดอายัด
    const [mortgageForm] = Form.useForm(); // ติดจำนอง, ติดขายฝาก

    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({});
    const token = localStorage.getItem("TOKEN");
    const [getimages, setGetImages] = useState([]); // รูปภาพทั้งหมด
    const [imagesBackup, setImagesBackup] = useState([]); // รูปภาพทั้งหมด
    const [dataEdit, setDataEdit] = useState({ ...dataForEdit }); //
    const [dataAssetList, setDataAssetList] = useState([]); // มีทรัพย์
    const [dataDataNoAssetList, setDataNoAssetList] = useState([]); // มีทรัพย์
    const [dataForCheckbox, setDataForCheckbox] = useState({}); //
    const [ch, setCh] = useState([]); // checkbox ติดอายัด,ติดจำนอง,ติดขายฝาก

    const [openModalView, setOpenModalView] = useState(false); // ดูข้อมูล
    const [dataForView, setdataForView] = useState(false);
    const [indes, setIndes] = useState();

    const [assetCustomer, setAssetCustomer] = useState([]); // state ไว้เก็บข้อมูลเจ้าของทรัพย์ 
    const [datasendForEdit, setDatasendForEdit] = useState([]); // 

    // โชว์ฟอร์ม
    const [showForm, setShowForm] = useState(false); // แสดงฟอร์มเพิ่มเจ้าของทรัพย์
    const [showAsset, setShowAsset] = useState(false); // แสดงฟอร์มทรัพย์
    const [showdatasendForEdit, setShowdatasendForEdit] = useState(false); // แสดงฟอร์มทรัพย์

    // แก้ไขเจ้าของทรัพย์ก่อนกดบันทคกข้อมูล
    const [showFormeditOwner, setShowFormeditOwner] = useState(false); // แสดงฟอร์มทรัพย์
    const [dataEditOwner, setdataEditOwner] = useState([]); // 

    // set Load Data
    const [loadData, setLoadData] = useState(false); // state ไว้เก็บข้อมูลเจ้าของทรัพย์ 

    // เลือกอำเภอ
    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [subdistricts, setSubdistricts] = useState([]);
    const [zipcode, setZipcode] = useState('');

    // Radio
    const [assetsRadioState, setAssetsRadioState] = useState(
        dataForEdit?.investigation === true ? 2
            : dataForEdit?.investigation === false ? 1
                : dataForEdit?.investigation === null && null);
    const [radioValue, setRadioValue] = useState(2); // state ไว้เก็บค่าของ Radio

    // images
    const [fileListPropertyInspection, setFileListPropertyInspection] = useState([]);
    const [fileListLocation, setFileListLocation] = useState([]);
    const [fileListMap, setFileListMap] = useState([]);
    const [fileListAssessment, setFileListAssessment] = useState([]);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [allImg, setAllImg] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadProvince();
        loadAddasset();
    }, [loadData]);

    // console.log("dataAssetList", dataAssetList);
    // console.log("dataDataNoAssetList", dataDataNoAssetList);
    // console.log("dataForEdit", dataForEdit);
    // console.log("assetsRadioState", assetsRadioState);
    // console.log("showAsset", showAsset);
    // console.log("imagesBackup", imagesBackup);
    // console.log("getimages", getimages);
    // console.log("dataEdit", dataEdit);
    // console.log("radioValue", radioValue);
    // console.log("assetCustomer", assetCustomer);
    // console.log("datasendForEdit", datasendForEdit);
    // console.log("datas", datas);
    // console.log("index", index);
    // console.log("ch", ch);

    // Load Data New
    const handleLoadDataNew = (data) => {
        // console.log("data", data);
        if (data) {
            setLoadData(true)
        }
    }
    // Data New Owner Before Saver
    const handledataNewOwnerBefore = (values) => {
        // console.log("handlevaluesNewOwnerBefore", values);
        if (values) {
            setAssetCustomer((prev) => [
                {
                    landId: datasendForEdit?.length > 0 ? datasendForEdit?.landAreaId : 0,
                    acId: 0,
                    relation: values?.relation,
                    assetType: 2,
                    assetCustomer: {
                        ...values,
                        acId: 0,
                    },
                }
            ]);
        }
    }

    // delete New Owner Before Saver
    const handleDeleteOwner = (values) => {
        // console.log("handlevaluesNewOwnerBefore", values);
        setAssetCustomer((prev) =>
            prev.filter((_, index) => index !== values)
        );
    }

    const handleSetAddAssetsBtn = () => {
        // console.log("กดปุ่มเพิ่มทรัพย์");
        setShowAsset(true)
    }

    const loadAddasset = async () => { // โหลดจังหวัด
        const params = {
            assetId: dataForEdit ? dataForEdit?.assetId : 0
        }
        // console.log("params", params);

        try {
            setLoading(true);
            const response = await axios.post(
                POST_LOAD_ASSET,
                params,
                {
                    headers: {
                        Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
                    },
                }
            );
            console.log("response loadAssetData", response?.data?.assetLandArea);
            if (response?.data) {
                setDataAssetList(response?.data?.assetLandArea)
                setGetImages(response?.data?.urlPath ? [response?.data?.urlPath] : []);
                setImagesBackup(response?.data?.urlPath ? [response?.data?.urlPath] : []);
                setShowAsset(false)
                setLoadData(false)
            }
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    const loadProvince = async () => { // โหลดจังหวัด
        try {
            setLoading(true);
            const response = await axios.get("https://shark-app-j9jc9.ondigitalocean.app/lawyer/lands/provinces");
            // console.log("response loadProvince", response?.data);
            setProvinces(response.data); // เก็บข้อมูลที่ได้จาก backend
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    // ----------------------------------------- Start handleFormChange ----------------------------------------- //
    const handleFormChange = (index, field, values) => {  // การกรอกข้อมูลในฟอร์ม
        const newData = [...dataForEdit ? [dataForEdit] : []];
        // console.log("values", values);
        // console.log("field", field);
        // console.log("dataForEdit", dataForEdit);

        let updatedItem = { [field]: values };

        if (field === "seizedData") { // ติดอายัด
            delete updatedItem.mortgageData;
        }

        if (field === "mortgageData") { // ติดจำนอง, ติดขายฝาก
            delete updatedItem.seizedData;
        }

        newData[index] = updatedItem;
        // console.log("updatedItem++++", updatedItem);
        // console.log("newData++++", newData);
        setDataForCheckbox(updatedItem?.[field])
        setDataEdit(newData);
    };
    // ----------------------------------------- Start handleFormChange ----------------------------------------- //

    // ----------------------------------------- Start Images ----------------------------------------- //
    const handleChangePropertyInspection = async (img, FileList, setFileList, type) => { // 1
        for (const removedFile of FileList.filter(file => file.status === 'removed')) {
            if (allImg.some(img => img.imageCompressedFile.name === removedFile.name && img.type === 1)) {
                const updatedAllImg = allImg.filter(img => !(img.imageCompressedFile.name === removedFile.name && img.type === 1));
                setAllImg(updatedAllImg);
            }
        }
        const filteredFileList = img.fileList.filter(file => file.size <= 5000000);
        setFileList(filteredFileList);
        setLoading(false)
    };

    const handleChangeLocation = async (img, FileList, setFileList, type) => { // 2
        for (const removedFile of FileList.filter(file => file.status === 'removed')) {
            if (allImg.some(img => img.imageCompressedFile.name === removedFile.name && img.type === type)) {
                const updatedAllImg = allImg.filter(img => !(img.imageCompressedFile.name === removedFile.name && img.type === type));
                setAllImg(updatedAllImg);
            }
        }
        const filteredFileList = img.fileList.filter(file => file.size <= 5000000);
        setFileList(filteredFileList);
        setLoading(false)
    };
    const handleChangeMap = async (img, FileList, setFileList, type) => { // 3
        for (const removedFile of FileList.filter(file => file.status === 'removed')) {
            if (allImg.some(img => img.imageCompressedFile.name === removedFile.name && img.type === type)) {
                const updatedAllImg = allImg.filter(img => !(img.imageCompressedFile.name === removedFile.name && img.type === type));
                setAllImg(updatedAllImg);
            }
        }
        const filteredFileList = img.fileList.filter(file => file.size <= 5000000);
        setFileList(filteredFileList);
        setLoading(false)
    };
    const handleChangeAssessment = async (img, FileList, setFileList, type) => { // 4
        for (const removedFile of FileList.filter(file => file.status === 'removed')) {
            if (allImg.some(img => img.imageCompressedFile.name === removedFile.name && img.type === type)) {
                const updatedAllImg = allImg.filter(img => !(img.imageCompressedFile.name === removedFile.name && img.type === type));
                setAllImg(updatedAllImg);
            }
        }
        const filteredFileList = img.fileList.filter(file => file.size <= 5000000);
        setFileList(filteredFileList);
        setLoading(false)
    };

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const beforeUpts = async (file, ty) => {
        try {
            setLoading(true)
            const compressedFile = await compressImage(file, ty);
            return Promise.resolve(compressedFile);
        } catch (error) {
            console.error('Image compression error:', error);
            message.error('Image compression failed.');
            return Promise.reject(); // เปลี่ยนให้ return Promise.reject() เมื่อไม่สามารถบีบอัดได้
        }
    };

    const compressImage = async (ez, types) => {
        var image = {};
        return new Promise(async (resolve) => {
            if (types !== 7) {
                if (ez.size > 4000000) {
                    console.log("4m ไม่ให้ส่ง");
                    resolve(true);  // บอกให้ระบบทราบว่ากระบวนการเสร็จสิ้น
                } else {
                    let quality;
                    if (ez.size >= 2500000 && ez.size <= 4000000) {
                        quality = 0.1;
                    } else if (ez.size >= 2000000 && ez.size <= 2499999) {
                        quality = 0.15;
                    } else if (ez.size >= 1500000 && ez.size <= 1999999) {
                        quality = 0.2;
                    } else if (ez.size >= 1000000 && ez.size <= 1499999) {
                        quality = 0.3;
                    } else {
                        quality = 0.5;
                    }

                    try {
                        // ใช้ Promise เพื่อบีบอัดรูปภาพ
                        const compressedFile = await new Promise((resolveCompress) => {
                            new Compressor(ez, {
                                quality: quality,
                                success: (result) => {
                                    resolveCompress(result);
                                },
                            });
                        });

                        const fileOptions = {
                            type: compressedFile.type,
                            lastModified: Date.now(),
                        };
                        const compressedFileAsFile = new File([compressedFile], ez.name, fileOptions);
                        image.imageCompressedFile = compressedFileAsFile;
                        image.type = types
                        allImg.push(image);
                        //setAllImg((prevAllImg) => [...prevAllImg, image]);

                        // ตรงนี้คือการ resolve ไฟล์ที่ถูกบีบอัด
                        resolve(image);
                    } catch (error) {
                        console.error('Image compression error:', error);
                        resolve(true);  // บอกให้ระบบทราบว่ากระบวนการเสร็จสิ้น
                    }
                }
            } else {
                // ... (โลจิกสำหรับ type 7)
                image.imageCompressedFile = ez;
                image.type = types
                allImg.push(image);
                //setAllImg((prevAllImg) => [...prevAllImg, image]);
                resolve(true);  // บอกให้ระบบทราบว่ากระบวนการเสร็จสิ้น
            }
        });
    };

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewVisible(true);
    };
    // ----------------------------------------- End Images ----------------------------------------- //
    // --- ฟังก์ชันดึงข้อมูลอำเภอ ตำบล รหัสไปรษณีย์ --- //
    const handleProvinceChange = async (prov_code) => {
        console.log('Selected province code:', prov_code);
        const params = {
            prov_code: String(prov_code)
        }
        // console.log("params", params);

        try {
            const response = await axios.get("https://shark-app-j9jc9.ondigitalocean.app/lawyer/lands/districts", { params });
            // console.log("อำเภอ", response?.data);
            setDistricts(response.data); // เก็บข้อมูลที่ได้จาก backend
        } catch (err) {
            console.log("err", err);
        } finally {
            console.log("โหลดเสร็จสิ้น");
        }
        setSubdistricts([]); // รีเซ็ตตำบลทุกครั้งที่เปลี่ยนจังหวัด
        setZipcode(''); // รีเซ็ตรหัสไปรษณีย์
    };
    const handleDistrictChange = async (selectedDistCode) => {
        // หา object ของอำเภอที่ตรงกับ dist_code
        const selectedDist = districts?.find(d => d.dist_code === selectedDistCode);
        if (!selectedDist) return;
        const { prov_code, dist_code } = selectedDist;
        const params = {
            prov_code,
            dist_code
        };
        // fetch ข้อมูลตำบลต่อจาก backend
        try {
            const response = await axios.get(
                "https://shark-app-j9jc9.ondigitalocean.app/lawyer/lands/sub-districts",
                { params }
            );
            // console.log("ตำบล", response?.data);
            setSubdistricts(response.data); // เก็บข้อมูลที่ได้จาก backend
        } catch (err) {
            console.log("err", err);
        } finally {
            console.log("โหลดเสร็จสิ้น");
        }
        setZipcode(''); // รีเซ็ตรหัสไปรษณีย์
    };
    const handleSubdistrictChange = (subdistrict_code) => {
        const sub = subdistricts.find(s => s.code === subdistrict_code);
        if (sub) {
            setZipcode(sub.zipcode); // ดึง zipcode จากตำบล
        }
    };
    // --- ฟังก์ชันดึงข้อมูลอำเภอ ตำบล รหัสไปรษณีย์ --- //

    // ฟังก์ชันเคลียร์ค่าทั้งหมด
    const clearAllForms = () => {
        form.resetFields();
        formaddperson.resetFields();
        formradio.resetFields();
        seizedForm.resetFields();
        mortgageForm.resetFields();
        setAssetCustomer([])
        setGetImages([]); // เคลียร์รูปภาพ
        setFileListPropertyInspection([]);
        setFileListLocation([]);
        setFileListMap([]);
        setFileListAssessment([]);
        setFormData({}); // ถ้ามีเก็บค่าไว้ใน state
    };

    // ฟังก์ชัน set ค่า radio
    const handleSetAssetsRadio = (value) => {
        console.log("value", value);
        if (value === 1) {
            setAssetsRadioState(value)
            loadAddasset()
            clearAllForms();
        } else {
            setShowAsset(true)
            setAssetsRadioState(value)
        }
    };

    // ฟังก์ชัน set ค่า checkbox ติดอายัด ติดจำนอง ติดขายฝาก ไม่ติดภาระ
    const handlecheckedValues = (index, values) => { // checkbox ติดอายัด,ติดจำนอง,ติดขายฝาก
        const newData = [dataForEdit];
        newData[index] = { ...newData[index], landAreaStatus: values[0] };
        const checked = values[0];
        setCh(checked)
        setDataEdit(newData);
    };

    const handleCancel = () => {
        setPreviewVisible(false);
    }

    const handleFormChanges = (_, allValues) => {
        setFormData(allValues);
    };

    const handleClose = () => {
        onClose(false);
    };

    // อัพเดต AssetCustomer
    const onFinish = (values) => {
        // console.log("ข้อมูลเจ้าของทรัพย์:", values);
        setAssetCustomer((prev) => [
            ...prev,
            {
                landId: datasendForEdit?.length > 0 ? datasendForEdit?.landAreaId : 0,
                acId: 0,
                relation: values?.relation,
                assetType: 2,
                assetCustomer: {
                    ...values,
                    acId: 0,
                },
            }
        ]);
        setShowForm(false)
    };

    const onCancels = () => {
        formaddperson.resetFields([]); // รีเซ็ตค่าในฟอร์ม
        formaddperson.setFieldsValue({
            cuscod: '',
            snam: '',
            fname: '',
            lname: '',
            relation: ''
        }); // เคลียร์ค่าฟอร์ม
        setShowForm(false)
        setAssetCustomer([])
    };

    // ฟังก์ชันอัพโหลดรูปภาพ
    const funcUploadImages = async (haveAssetsRadioState, resultImgs, id) => {
        const newFormData = new FormData();
        return new Promise(async (resolve, reject) => {
            try {
                setLoading(true)
                var status;
                newFormData.append('assetId', dataForEdit?.assetId);
                newFormData.append('landAreaId', haveAssetsRadioState === 2 ? id : 0); // ถ้ามีทรัพย์ให้ส่ง id ของ asset_land_area ไปด้วย
                for (const file of resultImgs) {
                    console.log("file", file)
                    var image = {}
                    newFormData.append('file', file.imageCompressedFile);
                    newFormData.append("type", file.type);
                    image.type = file.type
                }
                const response = await axios.post(
                    POST_UPLOAD_IMAGE,
                    // "http://localhost:8090/api-lawyer/upload-image-area",
                    newFormData,
                    {
                        headers: {
                            "Authorization": "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
                        },
                    });
                // console.log("response funcUploadImages", response?.data);
                if (response.data) {
                    if (haveAssetsRadioState === 1) {
                        console.log("ไม่มีทรัพย์ๅๅๅๅๅๅๅๅๅๅๅ");
                        handleSaveAssets(response.data)
                    } else {
                        console.log("มีทรัพย์");
                        message.success("บันทึกข้อมูลเรียบร้อย");
                        // handleLoadEdit(response?.data)
                        handleLoadEdit(dataForEdit?.assetId, true);
                        setAssetsRadioState(2)
                        setShowAsset(false)
                        setLoading(false)
                    }
                }
            } catch (error) {
                console.log("error funcUploadImages", error);
                message.success("บันทึกข้อมูลไม่สำเร็จ");
            } finally {
                setLoading(false);
                console.log("OK")
                setShowAsset(false)
                clearAllForms()
                setLoadData(true)
            }
        });
    }
    const handleSaveAssets = async (dataPath) => {
        const params = {
            assetId: dataForEdit ? dataForEdit?.assetId : 0,
            investigation: false, // 0=ไม่มีทรัพย์,1=มีทรัพย์
            urlPath: dataPath // path รูปภาพ
        }
        console.log("params handleSaveAssets asdasd", params);
        try {
            const response = await axios.post(
                POST_ADD_ASSET,
                params,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
                    },
                }
            );
            console.log("response_+_+_+_+_+_+_+", response);
            if (response?.status === 200) {
                message.success("บันทึกข้อมูลเรียบร้อย");
                // handleLoadEdit(response?.data)
                handleLoadEdit(dataForEdit?.assetId, false);
                setAssetsRadioState(2)
                setShowAsset(false)
                clearAllForms()
                handleClose()
                setLoading(false);
            } else {
                message.error("บันทึกข้อมูลไม่สำเร็จ");
                setShowAsset(false)
                setLoading(false);
            }
        } catch (error) {
            console.log("error handleSaveAssets", error);
            message.error("บันทึกข้อมูลไม่สำเร็จ");
            setLoading(false);
            setShowAsset(false)
        }
    }

    // ------------------------- ลบรูปกรณี ไม่มีทรัพย์ --------------------------- //
    const showConfirmDeleteIMGGua = (value) => {
        confirm({
            title: 'คุณต้องการที่จะลบรูปหรือไม่...?',
            content: 'กด OK เพื่อยืนยันการลบ',
            onOk() {
                handleDeleteIMG(value)
            },
            onCancel() {
                // setSelectedImages([]); // เคลียร์ค่า
            },
        });
    };

    const handleDeleteIMG = async (value) => {
        // console.log("value", value);
        const params = {
            assetId: dataForEdit ? dataForEdit?.assetId : 0,
            urlPath: value[0]
        }
        console.log("params delete images", params);
        try {
            setLoading(true);
            const response = await axios.delete(DELETE_IMAGE_NOT_ASSET, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=", // ⚠️ Hardcoded credentials
                },
                data: params,
            });
            console.log("response", response?.data);
            if (response.data) {
                message.success("ลบข้อมูลสำเร็จ");
                console.log("res.data", response.data);
                setGetImages([]);
                setLoading(false)
            } else {
                message.error("ไม่สามารถลบข้อมูลได้"); // ⚠️ ambiguous if response.data = {}
            }
        } catch (error) {
            if (error.response) {
                console.error("Server responded with error:", error.response.status, error.response.data);
            } else if (error.request) {
                console.error("No response received:", error.request);
            } else {
                console.error("Error setting up request:", error.message);
            }
        } finally {
            setLoading(false); // ✅ make sure loading state resets
        }
    }

    // ลบ asset land Area
    const handleDelete = async (data, index) => {
        Modal.confirm({
            title: "ยืนยันการลบ",
            content: "คุณแน่ใจหรือไม่ว่าต้องการลบ asset นี้?",
            okText: "ลบ",
            okType: "danger",
            cancelText: "ยกเลิก",
            async onOk() {
                await deleteAsset(DELETE_ASSETLANDAREA, data); // ลบ asset ที่มีทรัพย์
            },
            onCancel() {
                console.log("ยกเลิกการลบ");
            },
        });
    };
    const deleteAsset = async (url, data) => {
        // console.log("url", url);
        // console.log("data", data);
        // extract params
        const params = { landAreaId: data?.landAreaId };
        console.log("params", params);
        try {
            setLoading(true);

            // axios.delete supports sending a request body with 'data'
            const response = await axios.delete(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=", // ⚠️ Hardcoded credentials
                },
                data: params,
            });
            console.log("response", response?.data);
            if (response.status === 200 || response.status === 204) {
                message.success("ลบข้อมูลเรียบร้อย"); // ✅ success message
                if (dataAssetList?.length > 1) {
                    console.log("> 1");
                    handleLoadEdit(data?.assetId, true);
                } else if (dataAssetList?.length === 1) {
                    console.log("= 1");
                    handleLoadEdit(data?.assetId, null);
                    handleClose()
                }
                setLoadData(true); // reload data after deletion
            } else {
                message.error("ไม่สามารถลบข้อมูลได้"); // ⚠️ ambiguous if response.data = {}
            }
        } catch (error) {
            if (error.response) {
                console.error("Server responded with error:", error.response.status, error.response.data);
            } else if (error.request) {
                console.error("No response received:", error.request);
            } else {
                console.error("Error setting up request:", error.message);
            }
        } finally {
            setLoading(false); // ✅ make sure loading state resets
        }
    };

    // เวลากดบันทึก มีทรัพย์
    const onSave = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();
            // console.log("values", values);
            // console.log("imagesBackup", imagesBackup[0]);
            const dataNew = { ...dataEdit[index] }
            // console.log("dataNew", dataNew);
            // console.log("dataEdit", dataEdit);
            // console.log("ch", ch);
            // console.log("dataForEdit", dataForEdit);
            const type = dataNew?.seizedData ? "assetSeized" : "assetMortgage";
            var pro = values?.provinceName ? values.provinceName.toString() : null
            var dis = values?.districtName ? values.districtName.toString() : null
            var sub = values?.subdistrictName ? values.subdistrictName.toString() : null
            delete values?.provinceName;
            delete values?.districtName;
            delete values?.subdistrictName;

            var params
            var URL
            if (imagesBackup?.length > 0) {
                console.log("if");
                URL = POST_EDIT_ASSET
                params = {
                    assetLandArea: {
                        ...values,
                        landAreaId: 0,
                        [type]: {
                            ...dataForCheckbox,
                            assetSeizedId: 0,
                            landAreaId: 0,
                        },
                        contractLandCustomer: assetCustomer ? assetCustomer : [],
                        province: pro,
                        district: dis,
                        subdistrict: sub,
                        zipcode: values?.zipcode,
                        userId: 888,
                        landAreaStatus: parseInt(ch),
                        assetId: dataForEdit?.assetId,
                        areaImage: getimages
                    },
                    assetHasLoanId: datas ? datas?.assetHasLoanId : null,
                    assetId: dataForEdit?.assetId,
                    customerId: dataForEdit?.customerId,
                    investigation: true, // 0=ไม่มีทรัพย์,1=มีทรัพย์
                    urlPath: imagesBackup[0], // path รูปภาพ
                    userId: 888,
                }
            } else {
                console.log("else");
                URL = POST_ADD_ASSET
                params = {
                    ...values,
                    assetId: dataForEdit?.assetId,
                    assetHasLoanId: datas?.assetHasLoanId,
                    CustomerId: dataForEdit?.customerId,
                    urlPath: "",
                    userId: 888,
                    landAreaStatus: ch ? parseInt(ch) : null, // ติดอายัด,ติดจำนอง,ติดขายฝาก
                    province: pro,
                    district: dis,
                    subdistrict: sub,
                    assetCustomer: assetCustomer ? assetCustomer : [],
                    investigation: assetsRadioState === 2 ? true : false,
                    [type]: dataForCheckbox,
                    images: [...allImg],
                    assetCustomer: assetCustomer ? assetCustomer.map((item) => ({
                        cuscod: item.assetCustomer?.cuscod,
                        snam: item.assetCustomer?.snam,
                        fname: item.assetCustomer?.fname,
                        lname: item.assetCustomer?.lname,
                        relation: item.assetCustomer?.relation,
                    })) : [],
                }
            }
            // ลบ key ที่ไม่ต้องการ 
            const AllImages = [...allImg];
            // console.log("params update Data", params);
            // console.log("AllImages", AllImages);
            // console.log("URL", URL);
            // console.log("assetsRadioState", assetsRadioState);

            if (assetsRadioState === 2) {
                console.log("มีทรัพย์");
                // มีทรัพย์จะสร้างทรัพย์ก่อน (assest_land_area) และส่ง id กลับมาเพื่อบันทึกรูปภาพ
                const response = await axios.post(
                    URL,
                    params,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
                        },
                    }

                );
                console.log("response", response?.data);
                if (response?.data) {
                    // check images
                    console.log("if");
                    if (assetsRadioState !== 1) {
                        console.log("if1");
                        if (AllImages?.length > 0) {
                            console.log("if11111");
                            await funcUploadImages(assetsRadioState, AllImages, response?.data);
                        } else {
                            console.log("else 11111");
                            message.success("บันทึกข้อมูลเรียบร้อย");
                            setShowAsset(false)
                            setAssetsRadioState(2)
                            clearAllForms()
                            setLoading(false);
                        }
                    }
                }
            } else {
                console.log("ไม่มีทรัพย์");
                // จะทำการบันทึกรูปภาพก่อน จากนั้นคืน path และเก็บไว้ที่ตัวแปร urlPath เป็น string
                if (AllImages?.length > 0) {
                    await funcUploadImages(assetsRadioState, params?.images, 0);
                }
            }
        } catch (err) {
            console.log("Validation failed:", err);
            message.error("บันทึกข้อมูลไม่สำเร็จ");
            setLoading(false);
        }
    };

    const handleCheckboxChange = (checkedValues) => {
        let newChecked = [...checkedValues];

        if (newChecked.includes("4")) {
            newChecked = ["4"];
        } else {
            newChecked = newChecked.filter((val) => val !== "4");
        }

        if (
            newChecked.includes("1") &&
            (newChecked.includes("2") || newChecked.includes("3"))
        ) {
            message.warning("ไม่สามารถเลือก 'ติดอายัด' พร้อมกับ 'ติดจำนอง/ติดขายฝาก' ได้");
            newChecked = ["1"];
        }

        if (
            (newChecked.includes("2") || newChecked.includes("3")) &&
            newChecked.includes("1")
        ) {
            message.warning("ไม่สามารถเลือก 'ติดจำนอง/ติดขายฝาก' พร้อมกับ 'ติดอายัด' ได้");
            newChecked = newChecked.filter((val) => val !== "1");
        }

        if (newChecked.includes("2") || newChecked.includes("3")) {
            const lastSelected = newChecked[newChecked.length - 1];
            if (lastSelected === "2" || lastSelected === "3") {
                newChecked = [lastSelected];
            }
        }

        // ✅ update ฟอร์ม
        form.setFieldsValue({ landAreaStatus: newChecked });
        handlecheckedValues(index, newChecked);
    };

    return (
        <Modal
            open={open}
            onCancel={handleClose}
            width={1200}
            footer={null}
            title="ข้อมูลทรัพย์สิน"
        >
            <Spin spinning={loading} size='large' tip=" Loading... ">
                <Row justify={'center'} gutter={[16, 16]}>
                    {dataAssetList?.map((g, indexs) => {
                        // console.log("g", g);
                        // console.log("indexs", indexs);
                        return (
                            <Col xs={24} sm={24} md={12} lg={8}>
                                <Card
                                    type="inner"
                                    key={g.assetId || g.landId || indexs}
                                    title={
                                        <div style={{ textAlign: "center", width: "100%", fontWeight: "600", fontSize: "18px" }}>
                                            {`💰 ทรัพย์ (${indexs + 1})`}
                                        </div>
                                    }
                                    style={{
                                        width: "100%",
                                        borderRadius: "16px",
                                        border: "none",
                                        boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
                                        overflow: "hidden",
                                    }}
                                    actions={[
                                        <Button
                                            type="text"
                                            danger
                                            icon={<DeleteOutlined />}
                                            style={{
                                                borderRadius: "8px",
                                                background: "red",
                                                color: "white"
                                            }}
                                            onClick={() => handleDelete(g)}
                                        >
                                            ลบ
                                        </Button>,
                                        <Button
                                            type="text"
                                            icon={<EditOutlined />}
                                            onClick={() => {
                                                console.log("เลือกคนที่ index:", indexs, "ข้อมูล:", g);
                                                setDatasendForEdit(g);
                                                // setIndes(indexs);
                                                setShowdatasendForEdit(true);
                                            }}
                                            style={{
                                                borderRadius: "8px",
                                                background: "gray",
                                                color: "white"
                                            }}
                                        >
                                            แก้ไข
                                        </Button>,
                                        <Button
                                            type="text"
                                            icon={<SearchOutlined />}
                                            onClick={() => {
                                                setdataForView(g)
                                                setIndes(indexs);
                                                setOpenModalView(true);
                                            }}
                                            style={{
                                                borderRadius: "8px",
                                                background: "blue",
                                                color: "white"
                                            }}
                                        >
                                            ดูข้อมูล
                                        </Button>
                                    ]}
                                >
                                    <p><strong>เลขโฉนดที่ดิน : </strong><b style={{ color: "green" }}>{g?.numberLand || "-"} </b></p>
                                    <p><strong>จังหวัด : </strong> {g?.provinceName || "-"}</p>
                                    <p><strong>อำเภอ : </strong> {g?.districtName || "-"}</p>
                                    <p><strong>ตำบล : </strong> {g?.subdistrictName || "-"}</p>
                                    <p><strong>รหัสไปรษณีย์ : </strong> {g?.zipcode || "-"}</p>
                                    <p><strong>ราคาที่ดิน : </strong> {g?.landPrice || "-"}</p>
                                    <p><strong>ชื่อสถานที่ : </strong> {g?.nameMap || "-"}</p>
                                    <p><strong>ละติจูด : </strong> {g?.lat || "-"}</p>
                                    <p><strong>ลองจิจูด : </strong> {g?.lng || "-"}</p>
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
                {
                    (() => {
                        // หา customer ที่ assetId ตรงกัน
                        const matchedCustomerB = dataAssetList?.find(c => c?.assetId === dataForEdit?.assetId);
                        // ถ้ามี customer ตรงกัน และ investigation === true
                        if (matchedCustomerB) {
                            return (
                                <div style={{ textAlign: "center", margin: 16 }}>
                                    <Space>
                                        <Button
                                            size="large"
                                            style={{ background: 'green', color: 'white' }}
                                            onClick={() => handleSetAddAssetsBtn()}
                                        >
                                            เพิ่ททรัพย์(มีทรัพย์อยู่แล้ว)
                                        </Button>
                                    </Space>
                                </div>
                            );
                        } else {
                            return (
                                <div style={{ textAlign: "center", margin: 16 }}>
                                    <Radio.Group
                                        onChange={(e) => handleSetAssetsRadio(e.target.value)}
                                        value={assetsRadioState} // กัน undefined
                                        style={{ marginBottom: 12 }}
                                    >
                                        <Radio value={2}>มีทรัพย์</Radio>
                                        <Radio value={1}>ไม่มีทรัพย์</Radio>
                                    </Radio.Group>
                                </div>
                            );
                        }
                    })()
                }

                {showAsset ?
                    <Row justify="center" gutter={[16, 16]} align="middle">
                        {assetsRadioState === 2 || dataForEdit?.investigation === true ? (
                            <>
                                <Col span={24} style={{ textAlign: "center", marginBottom: 4 }}>

                                    <Form form={formradio} layout="vertical">
                                        <h4>สถานะภาระทรัพย์</h4>
                                        <Form.Item name="landAreaStatus">
                                            <Checkbox.Group
                                                onChange={handleCheckboxChange}
                                                style={{ width: "100%" }}
                                            >
                                                <Row justify={"center"} gutter={[16, 16]} >
                                                    <Space wrap size="large">
                                                        <Checkbox value="1">ติดอายัด</Checkbox>
                                                        <Checkbox value="2">ติดจำนอง</Checkbox>
                                                        <Checkbox value="3">ติดขายฝาก</Checkbox>
                                                        <Checkbox value="4">ไม่ติดภาระ</Checkbox>
                                                    </Space>
                                                </Row>
                                            </Checkbox.Group>
                                        </Form.Item>
                                    </Form>
                                </Col>

                                <Row justify="center" gutter={[16, 16]} style={{ width: '100%' }}>
                                    {/* อัพโหลดรูปภาพ */}
                                    <Divider style={{ margin: 5 }} >อัพโหลดรูปภาพ</Divider>
                                    <Col xs={24}>
                                        <Row justify="center">

                                            <Form.Item
                                                style={{ textAlign: 'center', width: '300px' }}
                                                label="รูปสถานที่"
                                            >
                                                {getimages ?
                                                    <Row gutter={[16, 16]} justify="center">
                                                        <Col span={24} style={{ textAlign: 'center' }}>
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '16px' }}>
                                                                {getimages?.filter(img => img?.type === 2).map((imageData, index) => {
                                                                    return (
                                                                        <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
                                                                            <Image
                                                                                width={'50px'}
                                                                                src={`${GET_LOAD_IMAGE}/${imageData?.path}?token=${token}`}
                                                                                alt={`รูปภาพ ${index}`}
                                                                                style={{ display: 'block', borderRadius: '8px' }}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    : null}
                                                <Upload
                                                    accept="image/*"
                                                    multiple={true}
                                                    style={{ textAlign: 'center' }}
                                                    listType="picture-card"
                                                    fileList={fileListLocation}
                                                    onPreview={handlePreview}
                                                    onChange={(value) => handleChangeLocation(value, fileListLocation, setFileListLocation, 2)}
                                                    beforeUpload={(file) => beforeUpts(file, 2).then(() => false).catch(() => true)}
                                                >
                                                    {fileListLocation?.length >= 20 ? null : (
                                                        <div>
                                                            <PlusOutlined />
                                                            <div className="ant-upload-text">upload</div>
                                                        </div>
                                                    )}
                                                </Upload>
                                                <Modal open={previewVisible} onCancel={handleCancel}>
                                                    <img alt="ตัวอย่างรูปภาพ" style={{ width: '100%' }} src={previewImage} />
                                                </Modal>
                                            </Form.Item>

                                            <Form.Item
                                                style={{ textAlign: 'center', width: '300px' }}
                                                label="รูปแผนที่"
                                            >
                                                {getimages ?
                                                    <Row gutter={[16, 16]} justify="center">
                                                        <Col span={24} style={{ textAlign: 'center' }}>
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '16px' }}>
                                                                {getimages?.filter(img => img?.type === 3).map((imageData, index) => {
                                                                    return (
                                                                        <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
                                                                            <Image
                                                                                width={'50px'}
                                                                                src={`${GET_LOAD_IMAGE}/${imageData?.path}?token=${token}`}
                                                                                alt={`รูปภาพ ${index}`}
                                                                                style={{ display: 'block', borderRadius: '8px' }}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    : null}
                                                <Upload
                                                    accept="image/*"
                                                    multiple={true}
                                                    style={{ textAlign: 'center' }}
                                                    listType="picture-card"
                                                    fileList={fileListMap}
                                                    onPreview={handlePreview}
                                                    onChange={(value) => handleChangeMap(value, fileListMap, setFileListMap, 3)}
                                                    beforeUpload={(file) => beforeUpts(file, 3).then(() => false).catch(() => true)}
                                                >
                                                    {fileListMap?.length >= 20 ? null : (
                                                        <div>
                                                            <PlusOutlined />
                                                            <div className="ant-upload-text">upload</div>
                                                        </div>
                                                    )}
                                                </Upload>
                                                <Modal open={previewVisible} onCancel={handleCancel}>
                                                    <img alt="ตัวอย่างรูปภาพ" style={{ width: '100%' }} src={previewImage} />
                                                </Modal>
                                            </Form.Item>

                                            <Form.Item
                                                style={{ textAlign: 'center', width: '300px' }}
                                                label="รูปใบประเมิน"
                                            >
                                                {getimages ?
                                                    <Row gutter={[16, 16]} justify="center">
                                                        <Col span={24} style={{ textAlign: 'center' }}>
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '16px' }}>
                                                                {getimages?.filter(img => img?.type === 4).map((imageData, index) => {
                                                                    return (
                                                                        <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
                                                                            <Image
                                                                                width={'50px'}
                                                                                src={`${GET_LOAD_IMAGE}/${imageData?.path}?token=${token}`}
                                                                                alt={`รูปภาพ ${index}`}
                                                                                style={{ display: 'block', borderRadius: '8px' }}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    : null}
                                                <Upload
                                                    accept="image/*"
                                                    multiple={true}
                                                    style={{ textAlign: 'center' }}
                                                    listType="picture-card"
                                                    fileList={fileListAssessment}
                                                    onPreview={handlePreview}
                                                    onChange={(value) => handleChangeAssessment(value, fileListAssessment, setFileListAssessment, 4)}
                                                    beforeUpload={(file) => beforeUpts(file, 4).then(() => false).catch(() => true)}
                                                >
                                                    {fileListAssessment?.length >= 20 ? null : (
                                                        <div>
                                                            <PlusOutlined />
                                                            <div className="ant-upload-text">upload</div>
                                                        </div>
                                                    )}
                                                </Upload>
                                                <Modal open={previewVisible} onCancel={handleCancel}>
                                                    <img alt="ตัวอย่างรูปภาพ" style={{ width: '100%' }} src={previewImage} />
                                                </Modal>
                                            </Form.Item>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row justify="center" gutter={[16, 16]} style={{ width: '100%' }}>
                                    <Col xs={24} md={12} >
                                        {ch === "1" ? ( // กรณีติดอายัด
                                            <Card
                                                size="small"
                                                title={<div style={{ textAlign: "center" }}>รายละเอียดกรณีติดอายัด</div>}
                                                bordered={false}
                                                style={{ padding: '12px' }}
                                            >
                                                <Form
                                                    form={seizedForm}
                                                    layout="vertical"
                                                    initialValues={dataForEdit[index]?.assetSeized || {}}
                                                    onValuesChange={(changedValues, allValues) =>
                                                        handleFormChange(index, "seizedData", allValues)
                                                    }
                                                >
                                                    <Form.Item
                                                        label="ชื่อเจ้าของคำพิพากษา"
                                                        name="judgementOwner"
                                                        rules={[{ required: true, message: "กรุณากรอกชื่อเจ้าของคำพิพากษา" }]}
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                    <Form.Item
                                                        label="เลขคดีแดง"
                                                        name="caseNumber"
                                                        rules={[{ required: true, message: "กรุณากรอกเลขคดีแดง" }]}
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                    <Form.Item
                                                        label="ราคาประเมิน"
                                                        name="valuationPrice"
                                                        rules={[{ required: true, message: "กรุณากรอกราคาประเมิน" }]}
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                    <Form.Item
                                                        label="เจ้าพนักงานบังคับคดี"
                                                        name="enforcementOfficer"
                                                        rules={[{ required: true, message: "กรุณากรอกเจ้าพนักงานบังคับคดี" }]}
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                    <Form.Item
                                                        label="ชื่อสำนักงาน"
                                                        name="officeName"
                                                        rules={[{ required: true, message: "กรุณากรอกชื่อสำนักงาน" }]}
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </Form>
                                            </Card>
                                        ) : (ch === "2" || ch === "3") ? ( // กรณีติดจำนอง/ขายฝาก 
                                            <Card
                                                size="small"
                                                title={<div style={{ textAlign: "center" }}>รายละเอียดกรณีติดจำนอง/ขายฝาก</div>}
                                                bordered={false}
                                                style={{ padding: '12px' }}
                                            >
                                                <Form
                                                    form={mortgageForm}
                                                    layout="vertical"
                                                    initialValues={dataForEdit[index]?.assetMortgage || {}}
                                                    onValuesChange={(changedValues, allValues) =>
                                                        handleFormChange(index, "mortgageData", allValues)
                                                    }
                                                >
                                                    <Form.Item
                                                        label="เจ้าหนี้จำนอง"
                                                        name="mortgageCreditor"
                                                        rules={[{ required: true, message: "กรุณากรอกเจ้าหนี้จำนอง" }]}
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                    <Form.Item
                                                        label="วันทำสัญญา"
                                                        name="contractDate"
                                                        rules={[{ required: true, message: "กรุณาเลือกวันทำสัญญา" }]}
                                                    >
                                                        <DatePicker style={{ width: "100%", height: "40px" }} />
                                                    </Form.Item>
                                                    <Form.Item
                                                        label="ยอดหนี้จำนอง"
                                                        name="mortgageDebt"
                                                        rules={[{ required: true, message: "กรุณากรอกยอดหนี้จำนอง" }]}
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                    <Form.Item
                                                        label="กำหนดไถ่ถอน"
                                                        name="redemptionDate"
                                                        rules={[{ required: true, message: "กรุณาเลือกกำหนดไถ่ถอน" }]}
                                                    >
                                                        <DatePicker style={{ width: "100%", height: "40px" }} />
                                                    </Form.Item>
                                                </Form>
                                            </Card>
                                        ) :
                                            <Row
                                                justify="center"
                                                align="middle"
                                                style={{ minHeight: "100%", display: "flex" }}
                                            >
                                                <Col
                                                    span={24}
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Card style={{ textAlign: "center", border: "none" }}>
                                                        <h2>ติ๊ก checkbox สถานะภาระทรัพย์เพื่อโชว์ฟอร์ม</h2>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        }
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Card
                                            title={<div style={{ textAlign: "center" }}>รายละเอียดที่ดิน</div>}
                                            style={{ padding: '12px' }}
                                            bordered={false}
                                        >
                                            <Form
                                                form={form}
                                                layout="vertical"
                                                onValuesChange={handleFormChanges}
                                            >
                                                <Row justify={'center'}>
                                                    <Col xs={24} sm={12} style={{ textAlign: 'center' }}>
                                                        <Form.Item
                                                            style={{ width: '90%' }}
                                                            label="เลขที่ดิน"
                                                            name="numberLand"
                                                            rules={[{ required: true, message: "กรุณากรอกเลขที่ดิน" }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={12} style={{ textAlign: 'center' }}>
                                                        <Form.Item
                                                            style={{ width: '90%' }}
                                                            label="เลขระวาง"
                                                            name="numberLandlawang"
                                                            rules={[{ required: true, message: "กรุณากรอกเลขระวาง" }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={12} style={{ textAlign: 'left' }}>
                                                        <Form.Item
                                                            style={{ width: '90%' }}
                                                            label="จังหวัด"
                                                            name="provinceName"
                                                            rules={[{ required: true, message: "กรุณากรอกจังหวัด" }]}
                                                        >
                                                            <Select
                                                                placeholder="เลือกจังหวัด"
                                                                onChange={handleProvinceChange}
                                                                // value={provinc}
                                                                style={{ height: '40px' }}
                                                            >
                                                                {provinces?.map(prov => (
                                                                    <Option key={prov.id} value={prov.prov_code}>{prov.prov_desc}</Option>
                                                                ))}
                                                            </Select>

                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={12} style={{ textAlign: 'left' }}>
                                                        <Form.Item
                                                            style={{ width: '90%' }}
                                                            label="อำเภอ"
                                                            name="districtName"
                                                            rules={[{ required: true, message: "กรุณากรอกอำเภอ" }]}
                                                        >
                                                            <Select
                                                                placeholder="เลือกอำเภอ"
                                                                onChange={handleDistrictChange}
                                                                style={{ height: '40px' }}
                                                            >
                                                                {districts?.map(d => (
                                                                    <Option key={d.dist_code} value={d.dist_code}>
                                                                        {d.dist_desc}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={12} style={{ textAlign: 'left' }}>
                                                        <Form.Item
                                                            style={{ width: '90%' }}
                                                            label="ตำบล"
                                                            name="subdistrictName"
                                                            rules={[{ required: true, message: "กรุณากรอกตำบล" }]}
                                                        >
                                                            <Select
                                                                placeholder="เลือกตำบล"
                                                                onChange={handleSubdistrictChange}
                                                                style={{ height: '40px' }}
                                                            >
                                                                {subdistricts?.map(s => (
                                                                    <Option
                                                                        key={s.sub_dist_code}
                                                                        value={s.sub_dist_code}
                                                                    >
                                                                        {s.sub_dist_desc}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={12} style={{ textAlign: 'center' }}>
                                                        <Form.Item
                                                            style={{ width: '90%' }}
                                                            label="รหัสไปรษณีย์"
                                                            name="zipcode"
                                                            rules={[{ required: true, message: "กรุณากรอกรหัสไปรษณีย์" }]}
                                                        >
                                                            <Input value={zipcode} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={12} style={{ textAlign: 'center' }}>
                                                        <Form.Item
                                                            style={{ width: '90%' }}
                                                            label="ราคาที่ดิน"
                                                            name="landPrice"
                                                            rules={[{ required: true, message: "กรุณากรอกราคาที่ดิน" }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={12} style={{ textAlign: 'center' }}>
                                                        <Form.Item
                                                            style={{ width: '90%' }}
                                                            label="ชื่อสถานที่"
                                                            name="nameMap"
                                                            rules={[{ required: true, message: "กรุณากรอกชื่อสถานที่" }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={12} style={{ textAlign: 'center' }}>
                                                        <Form.Item
                                                            style={{ width: '90%' }}
                                                            label="ละติจูด"
                                                            name="lat"
                                                            rules={[{ required: true, message: "กรุณากรอกละติจูด" }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={12} style={{ textAlign: 'center' }}>
                                                        <Form.Item
                                                            style={{ width: '90%' }}
                                                            label="ลองจิจูด"
                                                            name="lng"
                                                            rules={[{ required: true, message: "กรุณากรอกลองจิจูด" }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Card>
                                    </Col>
                                </Row>
                                <Divider style={{ margin: 5 }} />
                                <Row justify={'center'} gutter={[16, 16]} style={{ width: '100%' }}>
                                    <Col span={24} style={{ textAlign: "center", marginBottom: 4 }}>
                                        {assetCustomer?.length > 0 ? (
                                            <>
                                                <h4 style={{ fontSize: "20px", fontWeight: "700", marginBottom: "12px" }}>
                                                    เจ้าของทรัพย์ที่มี
                                                </h4>
                                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                                                    {assetCustomer?.map((owner, idx) => {
                                                        // console.log("owner", owner);
                                                        return (
                                                            <Card
                                                                key={idx}
                                                                bordered
                                                                style={{
                                                                    borderRadius: "12px",
                                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                                                    padding: "12px",
                                                                    marginBottom: "12px",
                                                                    width: "350px",
                                                                }}
                                                            >
                                                                {owner?.assetType === 2 && (
                                                                    <p
                                                                        style={{
                                                                            color: "#1677ff",
                                                                            fontWeight: 600,
                                                                            marginBottom: "8px",
                                                                        }}
                                                                    >
                                                                        📍 สืบลงพื้นที่
                                                                    </p>
                                                                )}

                                                                <p>
                                                                    <b>ชื่อ - สกุล :</b> {owner?.assetCustomer?.snam || "-"} {owner?.assetCustomer?.fname || "-"} {owner?.assetCustomer?.lname || "-"}
                                                                </p>
                                                                <p>
                                                                    <b>ความสัมพันธ์:</b> {owner?.assetCustomer?.relation || "-"}
                                                                </p>
                                                                {/* ปุ่ม Action */}
                                                                <Divider />
                                                                <Row justify="center">
                                                                    <Space>
                                                                        <Button
                                                                            type="primary"
                                                                            onClick={() => {
                                                                                setdataEditOwner(owner)
                                                                                setShowFormeditOwner(true)
                                                                            }}
                                                                        >
                                                                            ✏️ แก้ไข
                                                                        </Button>
                                                                        <Button
                                                                            danger
                                                                            onClick={() => handleDeleteOwner(idx)}
                                                                        >
                                                                            🗑️ ลบ
                                                                        </Button>
                                                                    </Space>
                                                                </Row>
                                                            </Card>
                                                        );
                                                    })}

                                                </div>
                                            </>
                                        ) : null}
                                    </Col>
                                </Row>
                                <h4 style={{ fontSize: '18px', fontWeight: '700' }}>เพิ่มเจ้าของทรัพย์ (กรณีทรัพย์ที่ไปสืบไม่ตรงกับในระบบ)</h4>
                                <Col span={24} style={{ textAlign: 'center' }}>
                                    <Radio.Group
                                        onChange={(e) => {
                                            console.log("e", e);
                                            setRadioValue(e.target.value)
                                            formaddperson.resetFields();
                                            setShowForm(false)
                                        }} // เก็บค่าที่เลือก
                                        value={radioValue}
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                    >

                                        <Radio value={1} style={{ fontSize: '18px', fontWeight: '700' }}>
                                            ใช่
                                        </Radio>
                                        <Radio value={2} style={{ fontSize: '18px', fontWeight: '700' }}>
                                            ไม่ใช่
                                        </Radio>
                                    </Radio.Group>
                                </Col>
                                <Row justify="center" style={{ margin: 8 }}>
                                    <Col span={24} style={{ textAlign: "center" }}>
                                        {radioValue === 1 && (
                                            <Button
                                                type="primary"
                                                size="large"
                                                onClick={() => {
                                                    setShowForm(!showForm)
                                                    formaddperson.resetFields();
                                                }}
                                            >
                                                เพิ่มเจ้าของทรัพย์
                                            </Button>
                                        )}
                                    </Col>
                                    {showForm && (
                                        <Card style={{ width: '100%', margin: "16px auto" }}>
                                            <Form
                                                form={formaddperson}
                                                layout="vertical"
                                                onFinish={onFinish}
                                            >
                                                <Row gutter={[16, 16]}>
                                                    <Col xs={24} sm={12} lg={8}>
                                                        <Form.Item
                                                            label="รหัสลูกค้า (cuscod)"
                                                            name="cuscod"
                                                            rules={[
                                                                { required: true, message: "กรุณากรอกรหัสลูกค้า" },
                                                                { pattern: /^[0-9]{1,13}$/, message: "กรุณากรอกเป็นตัวเลข ไม่เกิน 13 หลัก" }
                                                            ]}
                                                        >
                                                            <Input maxLength={13} />
                                                        </Form.Item>
                                                    </Col>

                                                    <Col xs={24} sm={12} lg={8}>
                                                        <Form.Item
                                                            label="คำนำหน้า (snam)"
                                                            name="snam"
                                                            rules={[{ required: true, message: "กรุณาเลือกคำนำหน้า" }]}
                                                        >
                                                            <Select style={{ height: '40px' }}>
                                                                <Option value="นาย">นาย</Option>
                                                                <Option value="นาง">นาง</Option>
                                                                <Option value="นางสาว">นางสาว</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>

                                                    <Col xs={24} sm={12} lg={8}>
                                                        <Form.Item
                                                            label="ชื่อจริง (fname)"
                                                            name="fname"
                                                            rules={[{ required: true, message: "กรุณากรอกชื่อจริง" }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>

                                                    <Col xs={24} sm={12} lg={8}>
                                                        <Form.Item
                                                            label="นามสกุล (lname)"
                                                            name="lname"
                                                            rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={12} lg={8}>
                                                        <Form.Item
                                                            label="ความสัมพันธ์ (relation)"
                                                            name="relation"
                                                            rules={[{ required: true, message: "กรุณากรอกความสัมพันธ์" }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Row justify={'end'}>
                                                    <Space>
                                                        <Button
                                                            danger
                                                            style={{ background: "red", color: "white", textAlign: "center" }}
                                                            onClick={onCancels}
                                                        >
                                                            ยกเลิก
                                                        </Button>
                                                        <Button type="primary" htmlType="submit" >
                                                            บันทึกเจ้าของทรัพย์
                                                        </Button>
                                                    </Space>
                                                </Row>
                                            </Form>
                                        </Card>
                                    )}
                                </Row>
                                <Row justify="center" gutter={[16, 16]} style={{ width: '100%' }}>
                                    <div style={{ textAlign: "right", margin: 8 }}>
                                        <Space>
                                            <Button
                                                style={{ background: "red", color: "white" }}
                                                size="large"
                                                onClick={() => {
                                                    setShowAsset(false)
                                                    clearAllForms()
                                                }}
                                            >
                                                ยกเลิก
                                            </Button>
                                            <Button
                                                type="primary"
                                                size="large"
                                                onClick={onSave}
                                            >
                                                บันทึกข้อมูล
                                            </Button>
                                        </Space>
                                    </div>
                                </Row>
                            </>

                        ) : assetsRadioState === 1 &&
                        <>
                            <Col span={22}>
                                <Row justify="center" gutter={[16, 16]} align={"middle"}>
                                    <Form.Item
                                        style={{ textAlign: 'center', width: '300px' }}
                                        label="ใบตรวจสอบทรัพย์"
                                    >
                                        {getimages?.length > 0 ?
                                            <Row gutter={[16, 16]} justify="center">
                                                <Col span={24} style={{ textAlign: 'center' }}>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '16px' }}>

                                                        <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
                                                            <Image
                                                                width={'200px'}
                                                                src={`${GET_LOAD_IMAGE}/${getimages}?token=${token}`}
                                                                alt={`รูปภาพ ${index}`}
                                                                style={{ display: 'block', borderRadius: '8px' }}
                                                            />
                                                        </div>

                                                    </div>
                                                    {getimages ? (
                                                        <Button
                                                            danger
                                                            type="primary"
                                                            onClick={() => showConfirmDeleteIMGGua(getimages)}
                                                            style={{ marginTop: '16px' }}
                                                        >
                                                            ลบรูปภาพ
                                                        </Button>
                                                    ) : null}
                                                </Col>
                                            </Row>
                                            :
                                            <>
                                                <Upload
                                                    accept="image/*"
                                                    multiple={true}
                                                    style={{ textAlign: 'center' }}
                                                    listType="picture-card"
                                                    fileList={fileListPropertyInspection}
                                                    onPreview={handlePreview}
                                                    onChange={(value) => handleChangePropertyInspection(value, fileListPropertyInspection, setFileListPropertyInspection, 1)}
                                                    beforeUpload={(file) => beforeUpts(file, 1).then(() => false).catch(() => true)}
                                                >
                                                    {fileListPropertyInspection?.length >= 20 ? null : (
                                                        <div>
                                                            <PlusOutlined />
                                                            <div className="ant-upload-text">upload</div>
                                                        </div>
                                                    )}
                                                </Upload>
                                                <Modal open={previewVisible} onCancel={handleCancel}>
                                                    <img alt="ตัวอย่างรูปภาพ" style={{ width: '100%' }} src={previewImage} />
                                                </Modal>
                                            </>
                                        }

                                    </Form.Item>
                                    <Divider style={{ margin: 5 }} />
                                </Row>
                                <div style={{ textAlign: "right", margin: 8 }}>
                                    <Space>
                                        <Button
                                            type="primary"
                                            size="large"
                                            onClick={onSave}
                                        >
                                            บันทึกข้อมูล(ไม่มีทรัพย์)
                                        </Button>
                                    </Space>
                                </div>
                            </Col>
                        </>
                        }
                    </Row>
                    : assetsRadioState === 1 ?
                        <>
                            <Col span={22}>
                                <Row justify="center" gutter={[16, 16]} align={"middle"}>
                                    <Form.Item
                                        style={{ textAlign: 'center', width: '300px' }}
                                        label="ใบตรวจสอบทรัพย์2"
                                    >
                                        {getimages?.length > 0 ?
                                            <Row gutter={[16, 16]} justify="center">
                                                <Col span={24} style={{ textAlign: 'center' }}>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '16px' }}>
                                                        <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
                                                            <Image
                                                                width={'200px'}
                                                                src={`${GET_LOAD_IMAGE}/${getimages}?token=${token}`}
                                                                alt={`รูปภาพ ${index}`}
                                                                style={{ display: 'block', borderRadius: '8px' }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <Button
                                                        danger
                                                        type="primary"
                                                        onClick={() => showConfirmDeleteIMGGua(getimages)}
                                                        style={{ marginTop: '16px' }}
                                                    >
                                                        ลบรูปภาพ
                                                    </Button>
                                                </Col>
                                            </Row>
                                            : <>
                                                <Upload
                                                    accept="image/*"
                                                    multiple={true}
                                                    style={{ textAlign: 'center' }}
                                                    listType="picture-card"
                                                    fileList={fileListPropertyInspection}
                                                    onPreview={handlePreview}
                                                    onChange={(value) => handleChangePropertyInspection(value, fileListPropertyInspection, setFileListPropertyInspection, 1)}
                                                    beforeUpload={(file) => beforeUpts(file, 1).then(() => false).catch(() => true)}
                                                >
                                                    {fileListPropertyInspection?.length === 1 ? null : (
                                                        <div>
                                                            <PlusOutlined />
                                                            <div className="ant-upload-text">upload</div>
                                                        </div>
                                                    )}
                                                </Upload>
                                                <Modal open={previewVisible} onCancel={handleCancel}>
                                                    <img alt="ตัวอย่างรูปภาพ" style={{ width: '100%' }} src={previewImage} />
                                                </Modal>
                                            </>}

                                    </Form.Item>
                                    <Divider style={{ margin: 5 }} />
                                </Row>
                                <div style={{ textAlign: "right", margin: 8 }}>
                                    <Space>
                                        <Button
                                            type="primary"
                                            size="large"
                                            onClick={onSave}
                                        >
                                            บันทึกข้อมูล(ไม่มีทรัพย์)
                                        </Button>
                                    </Space>
                                </div>
                            </Col>
                        </>
                        : dataForEdit?.investigation === null && null
                }
                <Divider style={{ margin: 5 }} />
            </Spin>
            {
                showdatasendForEdit ?
                    <ModalAssetForEdit
                        open={showdatasendForEdit}
                        onClose={setShowdatasendForEdit}
                        datasendForEdit={datasendForEdit}
                        provinces={provinces}
                        dataForEdit={dataForEdit}
                        datas={datas}
                        handleLoadDataNew={handleLoadDataNew}
                    />
                    : null
            }
            {
                showFormeditOwner ?
                    <ModalEditOwnerBeforeSave
                        open={showFormeditOwner}
                        close={setShowFormeditOwner}
                        dataEditOwner={dataEditOwner}
                        handledataNewOwnerBefore={handledataNewOwnerBefore}
                    />
                    : null
            }
            {
                openModalView ?
                    <ModelViewData
                        open={openModalView}
                        close={setOpenModalView}
                        index={index}
                        dataForView={dataForView}
                        provinces={provinces}
                        datas={datas}
                    />
                    : null
            }

        </Modal>
    )
}

export default ModalEditAsset